<template lang="pug">
Fragment
  article.list-article(v-if='values', v-for='value in values')
    a.list-article__link(:href="value.url")
      div.list-article__content
        h3.list-article__title {{value.title | trimedTitle}}
        time.list-article__time(:datetime='`${value.updated_at.origin}`') {{ value.updated_at.time_ago}}
        span.list-article__company-name--dummy {{ value.provider.name }}
        span.list-article__april.list-article__april--fool(v-if='value.aprilfool_type === 2') エイプリルフール関連
        span.list-article__april.list-article__april--dream(v-if='value.aprilfool_type === 3') #AprilDream
      div.list-article__image
        span.list-article__image-wrap.js-lazyload(:title='`${value.title}`', :data-bg='`${value.images.new_thumbs.s.file}`')
      span.list-article__april--dummy.list-article__april--fool(v-if='value.aprilfool_type === 2') エイプリルフール関連
      span.list-article__april--dummy.list-article__april--dream(v-if='value.aprilfool_type === 3') #AprilDream
      span.list-article__company-name
        a.list-article__company-name-link(:href='`/main/html/searchrlp/company_id/${value.provider.id}`', :title='`${value.provider.name}`') {{ value.provider.name }}
</template>
<script>
import { Fragment } from 'vue-fragment';

const TITLE_STRING_LIMIT = 55;

export default {
  name: 'AddElement',
  components: {
    Fragment
  },
  props: {
    valueProps: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      values: []
    };
  },
  watch: {
    valueProps (newValue, oldValue) {
      this.values = newValue;
    }
  },
  filters: {
    trimedTitle (title) {
      return title.length > TITLE_STRING_LIMIT ? `${title.substring(TITLE_STRING_LIMIT, 0)}…` : title;
    }
  }
};
</script>
